// pi-admin uses anonymous WAMP auth, never WAMP-CRA. Autobahn loads
// auth/cra.js at module init which require()s crypto-js, but the actual
// PBKDF2/HmacSHA256 calls only fire when CRA-based authentication is used.
// A throwing proxy lets module-load succeed while turning any accidental
// crypto-js call into a loud error rather than a silent no-op.
const stubProxy = new Proxy(
  {},
  {
    get() {
      throw new Error(
        "crypto-js stubbed: pi-admin uses anonymous WAMP auth, WAMP-CRA is not enabled",
      );
    },
  },
);

export default stubProxy;
